import { Fragment, Suspense } from 'react';

// @ts-expect-error types not yet defined
import CommonShopFilters from '@zola/component-shopping/src/components/common/shop/ShopFilters/CommonShopFilters/CommonShopFilters';
// @ts-expect-error types not yet defined
import CategoryTree from '@zola/component-shopping/src/components/shop/CategoryTree/CategoryTree';
import type { WCategoryView, WFacetView } from '@zola/svc-web-api-ts-client';

import { isMobile } from '../../../../lib/responsive';
import { FILTER_POSITION_SETTINGS } from '../../constants';

/**
 * Renders Category Tree, filters and "Clear all" button
 */
export const Sidebar = ({
  isCategoryPage,
  activeCategoryKey,
  useGridTiles,
  categoryFilter,
  facets,
  selectedFilters,
  openSections,
  frontTaxId,
  handleCategorySelect,
  handleClearAll,
  setOpenSections,
  setFilters,
  handleFilterSelect,
}: {
  isCategoryPage: boolean;
  activeCategoryKey: string;
  useGridTiles?: boolean;
  categoryFilter: WCategoryView[];
  facets: WFacetView[];
  selectedFilters: Record<string, Record<string, boolean>>;
  openSections: Record<string, boolean>;
  frontTaxId: string | null;
  handleCategorySelect: (category: WCategoryView) => void;
  handleClearAll: () => void;
  setOpenSections: (openSections: Record<string, boolean>) => void;
  setFilters: (value: Record<string, Record<string, boolean>>) => void;
  handleFilterSelect: (value: Record<string, Record<string, boolean>>) => void;
}) => {
  // Seriously WTF is this?
  // Here is where it came from: https://github.com/NewAmsterdamLabs/web-registry/commit/14f9556adce1483dd486e82291943d713e51d653#diff-f62e9015b65a87c5435ab6ab02f00336eaffa594b7b8f750247d9b5b098841efR849
  const isDesktop = isMobile();

  return (
    <>
      {useGridTiles && <div className="zola-shop-sidebar-title">Filter by</div>}
      {!isCategoryPage && categoryFilter && categoryFilter.length > 0 && (
        <Suspense fallback={<Fragment />}>
          <CategoryTree
            activeKey={activeCategoryKey || frontTaxId}
            categoryTreeList={categoryFilter}
            handleClick={handleCategorySelect}
            enableCategoryClear
            openSections={openSections}
            handleClearAll={handleClearAll}
            setOpenSections={setOpenSections}
          />
        </Suspense>
      )}
      {facets && (
        <Suspense fallback={<Fragment />}>
          <CommonShopFilters
            filterList={facets}
            onFilterSelect={handleFilterSelect}
            selectedFilters={selectedFilters}
            isDesktop={isDesktop}
            setFilters={setFilters}
            filterPosition={FILTER_POSITION_SETTINGS}
          />
        </Suspense>
      )}
    </>
  );
};
